import { render, staticRenderFns } from "./ClockLogsDetails.vue?vue&type=template&id=0fff1a5c"
import script from "./ClockLogsDetails.vue?vue&type=script&lang=js"
export * from "./ClockLogsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports